import { AdminTab } from "@/pages/admin/page";
import { Link } from "react-router-dom";

interface Props {
  activeTab: AdminTab;
  onTabChange: (tab: AdminTab) => void;
  onLogout: () => void;
}

const navItems: { id: AdminTab; label: string; icon: string; desc: string }[] = [
  { id: "reviews", label: "리뷰 관리", icon: "ri-star-line", desc: "리뷰 승인 및 답글" },
  { id: "inquiries", label: "문의 확인", icon: "ri-message-3-line", desc: "카카오/라인 문의내역" },
  { id: "channels", label: "채널 설정", icon: "ri-settings-3-line", desc: "카카오톡·라인 ID 연동" },
  { id: "airbnb", label: "에어비앤비 연동", icon: "ri-home-smile-line", desc: "숙소 URL 관리" },
];

export default function AdminSidebar({ activeTab, onTabChange, onLogout }: Props) {
  return (
    <aside className="fixed left-0 top-0 h-screen w-64 bg-white border-r border-stone-100 flex flex-col z-10">
      <div className="px-6 py-6 border-b border-stone-100">
        <Link to="/" className="flex items-center gap-2 mb-1">
          <div className="w-7 h-7 flex items-center justify-center">
            <i className="ri-arrow-left-line text-stone-400 text-sm"></i>
          </div>
          <span className="text-xs text-stone-400">사이트로 돌아가기</span>
        </Link>
        <h1 className="text-lg font-bold text-stone-800 mt-3">관리자 페이지</h1>
        <p className="text-xs text-stone-400 mt-0.5">후쿠오카 한인 숙소 관리</p>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onTabChange(item.id)}
            className={`w-full flex items-center gap-3 px-3 py-3 rounded-lg text-left transition-all cursor-pointer ${
              activeTab === item.id
                ? "bg-stone-800 text-white"
                : "text-stone-600 hover:bg-stone-50"
            }`}
          >
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
              <i className={`${item.icon} text-base`}></i>
            </div>
            <div>
              <p className="text-sm font-medium whitespace-nowrap">{item.label}</p>
              <p className={`text-xs whitespace-nowrap ${activeTab === item.id ? "text-stone-300" : "text-stone-400"}`}>
                {item.desc}
              </p>
            </div>
          </button>
        ))}
      </nav>

      <div className="px-4 py-4 border-t border-stone-100 space-y-2">
        <div className="flex items-center gap-3 px-2 py-1">
          <div className="w-8 h-8 rounded-full bg-stone-200 flex items-center justify-center flex-shrink-0">
            <i className="ri-user-line text-stone-500 text-sm"></i>
          </div>
          <div className="min-w-0">
            <p className="text-xs font-medium text-stone-700">관리자</p>
            <p className="text-xs text-stone-400 truncate">admin@fukuoka-stay.kr</p>
          </div>
        </div>
        <button
          onClick={onLogout}
          className="w-full flex items-center gap-2 px-3 py-2.5 rounded-lg text-stone-500 hover:bg-red-50 hover:text-red-500 transition-all cursor-pointer group"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-logout-box-r-line text-sm"></i>
          </div>
          <span className="text-sm whitespace-nowrap">로그아웃</span>
        </button>
      </div>
    </aside>
  );
}
